global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';

import 'lnkdigitalhub';
import 'lnkdigitalhub/assets/dist/digitalhub.css';

const Masonry = require('masonry-layout');

import imagesLoaded from 'imagesloaded';

$(document).ready(function() {
    // sticky scroll menu
    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let headroom  = new Headroom(headroomEl);
        headroom.init();
    }


    // stop scrolling body & menu icon change
    $('#mob-menu-btn').click(function(e){
        e.stopPropagation();
        if($(this).attr("aria-expanded") === "true"){
            $(document.body).addClass("m-site");
            $('.navbar-toggler-icon').addClass("d-none")
            $('.navbar-closer').removeClass("d-none")
        } else {
            $(document.body).removeClass("m-site");
            $('.navbar-closer').addClass("d-none")
            $('.navbar-toggler-icon').removeClass("d-none")
        }

    });

    // force scroll on mobilefootercollapse
    $('#mobilefootercollapse').on('shown.bs.collapse', function () {
        window.scrollTo({ top: $(this).offset().top, behavior: 'smooth'});
    })

    // change footer opener icon
    $('#mobilefooteropener').click(function () {
        if($('#mobilefooteropener').attr("aria-expanded") === "true"){
            $('#plusfooter').addClass('d-none');
            $('#minusfooter').removeClass('d-none');
        } else {
            $('#minusfooter').addClass('d-none');
            $('#plusfooter').removeClass('d-none');
        }
    })

    /*********************************
     * FILTER PLUGIN FOR PRODUCTS
     ********************************/
    $(".filter__label li").click(function(){

        var filterID = $(this).data("id");

        //Add active class to selected item
        $(this).addClass('active').siblings().removeClass('active');

        //filterig products
       if(filterID=="all"){
        filterProducts(".filter__product__result");
       } else{
        filterProducts(".s-"+filterID);
       }
    })

    function filterProducts(ID){
        var responsive = $(window).width();

        $(".filter__product__result").hide();

        if (responsive <= 767) {
            $(ID).stop(true, true).animate(
                {
                    height: 'toggle'
                },
                {
                    duration: 500,
                    specialEasing: {
                    height: "linear",
                },
            });
        } else{
            $(ID).stop(true, true).animate(
                {
                    width: 'toggle'
                },
                {
                    duration: 500,
                    specialEasing: {
                    width: "linear",
                },
            });
        }
    }

    /*********************************
     * CUSTOM TOGGLE
     ********************************/
    $(".applicazioni__item .applicazioni__header").click(function(){
        $(this).parent().toggleClass("active");
    })

    // slideDown for dropdown
    $('header .dropdown').on('show.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop().slideDown();
    }).on('hide.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop().slideUp();
    });

    /*********************************
     * Go To Top Button
    ********************************/
    var toTopBtn = $('#to-top');

    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
          } else {
            toTopBtn.fadeOut();
          }
    });
    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });
    /*********************************
    * Patch for slider animation
    ********************************/
   $('.home-swiper__info').fadeIn(1000);

    const blogSwiper = new Swiper('.blogSwiper', {

        breakpoints: {
            1200: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            767: {
                slidesPerView: 2,
                spaceBetween: 20
            }
        },

        // Navigation arrows
        navigation: {
            nextEl: '.blog-swiper-button-next',
            prevEl: '.blog-swiper-button-prev',
        },
    });

    // AOS animations
    AOS.init({
        duration: 700,
        once: true,
    });
    // custom spacing for HUB
    // $('.bgMenu').css('margin-bottom', '50px');

    const spMasonry = document.querySelector('.sp__masonry');
    if (spMasonry) {
    //     Promise.all(Array.from(document.images).filter(img => !img.complete).map(img => new Promise(resolve => {
    //         img.onload = img.onerror = resolve;
    //     }))).then(() => {
            var spMasonryObj = new Masonry(spMasonry, {
                resize: true,
                columnWidth: '.sp__masonry-sizer',
                itemSelector: 'none',
                percentPosition: true,
                stagger: 30,
                visibleStyle: { transform: 'translateY(0)', opacity: 1 },
                hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
            });

        imagesLoaded( spMasonry, function() {
            spMasonryObj.options.itemSelector = '.sp__masonry-item';
            let items = spMasonry.querySelectorAll('.sp__masonry-item');
            spMasonryObj.appended( items );
        });
            // $('.sp__masonry-item').each(function(fadeInDiv){
            //     $(this).delay(fadeInDiv * 50).fadeTo(250, 1);
            // });
            // $(spMasonry).imagesLoaded().progress( function() {
            //     spMasonry.masonry('layout');
            // });
        // });

    }

    let clamp_opener = $('.clamp_opener');
    let clamp_closer = $('.clamp_closer');
    let clampers = $('.line-clamp');

    $.each(clampers, function(key,el){
        if (el.scrollHeight <= el.clientHeight){
            $(el).siblings('.clamp_opener').hide()
        }
    });

    clamp_opener.on('click', function (e) {
        e.preventDefault()
        $(this).siblings('.text-div').removeClass('line-clamp');
        $(this).hide()
        $(this).siblings('.clamp_closer').show()
        spMasonryObj.layout()
    })

    clamp_closer.on('click', function (e) {
        e.preventDefault()
        $(this).siblings('.text-div').addClass('line-clamp');
        $(this).hide()
        $(this).siblings('.clamp_opener').show();
        spMasonryObj.layout()
    })
});


